import React, { FC } from 'react';
import styles from './SearchComponents.module.less';
import { SearchInputBar, SearchTypeSelector } from './SearchInputBar';
import { SearchFilterBar } from './SearchFilterBar';
import { Grid } from 'antd';
import Utils from '../../../utils/Utils';

export const SearchPanel: FC = () => {
  const bp = Grid.useBreakpoint();
  return (
    <div className={Utils.mergeClasses(styles.searchPanel, 'no-horizontal-scrollbar')}>
      <div className={styles.searchContentArea}>
        {/*{!bp.md && <SearchTypeSelector />}*/}
        {/*<SearchInputBar />*/}
        <SearchFilterBar />
      </div>
    </div>
  );
};
